export const geographyField = [
    {
        name: "geoId",
        label: "Geo ID",
        type: "text",
        readonly: true
    },
    {
        name: "country",
        label: "Country",
        type: "text",
        required: true
    },
    {
        name: "state",
        label: "State",
        type: "text",
        required: true
    },
    {
        name: "city",
        label: "City",
        type: "text",
        required: true
    },
    {
        name: "pincodeType",
        label: "Pincode Type",
        type: "select",
        option: ["Individual", "Range", "Range Excluding"],
        required: true
    },
    {
        name: "pincode",
        label: "Pincode",
        type: "text"
    },
    {
        name: "pincodeFrom",
        label: "Pincode From",
        type: "text"
    },
    {
        name: "pincodeTo",
        label: "Pincode To",
        type: "text"
    },
    {
        name: "excludedPincode",
        label: "Excluded Pincode",
        type: "text"
    },
    {
        name: "createdBy",
        label: "Created By",
        type: "text",
        readonly: true
    },
    {
        name: "createdDate",
        label: "Created Date",
        type: "text",
        readonly: true
    },
    {
        name: "updatedBy",
        label: "Updated By",
        type: "text",
        readonly: true
    },
    {
        name: "updatedDate",
        label: "Updated Date",
        type: "text",
        readonly: true
    }
];
